/** Display helper: missing/non-finite counts must never become zero. */

export const COUNT_NOT_AVAILABLE = 'Not available';

export function parseOptionalCount(value: unknown): number | null {
  if (typeof value === 'boolean') return null;
  if (value == null || value === '') return null;
  const numeric = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numeric) || numeric < 0) return null;
  return Math.floor(numeric);
}

export function formatOptionalCount(
  value: unknown,
  missingLabel = COUNT_NOT_AVAILABLE,
): string {
  const count = parseOptionalCount(value);
  if (count == null) return missingLabel;
  return new Intl.NumberFormat('en-US').format(count);
}

export function hasOptionalCount(value: unknown): boolean {
  return parseOptionalCount(value) != null;
}
